import type { Peep, SimState } from '../types';

/**
 * Release everything a peep's current task holds a claim on: dig orders, ore
 * piles, goods piles. The ONE place claim bookkeeping lives — movement
 * abandonment, incidents, and quits/dismissal all call this, so a new claim
 * kind added here is released everywhere at once.
 */
export function releaseTaskClaims(state: SimState, peep: Peep): void {
  if (peep.task.kind === 'toDig' || peep.task.kind === 'digging') {
    const order = state.orders.get(peep.task.col);
    if (order && order.claimedBy === peep.id) order.claimedBy = null;
  }
  if (peep.task.kind === 'toPile') {
    const pile = state.piles.get(peep.task.col);
    if (pile) pile.claimedDt = 0;
  }
  if (peep.task.kind === 'toGoodsPile') {
    const pile = state.goodsPiles.get(peep.task.col);
    if (pile) pile.claimedUnits = 0;
  }
  if (peep.task.kind === 'toOutputPickup') {
    const buildingId = peep.task.buildingId;
    const building = state.buildings.find((candidate) => candidate.id === buildingId);
    if (building) building.outputClaimedUnits = 0;
  }
}
